body:not(.show-administrator) .show-administrator {
  display: none !important;
}

.buttons .show-permissions {
  margin-left: 10px;
  margin-top: 8px;
}

body:not(.show-deleted) .show-deleted {
  display: none !important;
}

body:not(.show-inactive) .show-inactive {
  display: none !important;
}

body:not(.show-permissions) .show-permissions {
  display: none !important;
}

span.show-deleted {
  opacity: 0.6;
  text-decoration: line-through;
}

tr.show-deleted {
  td,
  td span,
  td div {
    text-decoration: line-through;
    opacity: 0.6;
  }

  .ms-Persona {
    opacity: 0.8;
    text-decoration: line-through;
  }

  .actions * {
    display: none;
  }
}
